import Tdg_FeedbackModelBase from '../_generated/modelBases/tdg-feedback-model-base';

export default class Tdg_FeedbackModel extends Tdg_FeedbackModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
